// src/components/HeroSection.jsx
import React, { useEffect, useState } from "react";

const HeroSection = ({
  sideImages = [
    "https://picsum.photos/seed/1/200/300",
    "https://picsum.photos/seed/1/200/300",
    "https://picsum.photos/seed/1/200/300",
  ],
  children,
}) => {
  const images = [
    "https://picsum.photos/seed/1/800/400",
    "https://picsum.photos/seed/2/800/400",
    "https://picsum.photos/seed/3/800/400",
    "https://picsum.photos/seed/4/800/400",
    "https://picsum.photos/seed/5/800/400",
  ];
  const [current, setCurrent] = useState(0);
  const len = images.length;
  const nextSlide = () => setCurrent((c) => (c + 1) % len);
  const prevSlide = () => setCurrent((c) => (c - 1 + len) % len);

  useEffect(() => {
    const id = setInterval(nextSlide, 3000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="w-full">
      {/* Carousel (unchanged) */}
      <div className="relative w-full">
        <div className="overflow-hidden rounded-lg h-[200px] md:h-[300px]">
          <div
            className="flex h-full transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {images.map((src, i) => (
              <div key={i} className="flex-shrink-0 w-full h-full relative">
                <img
                  src={src}
                  alt={`Slide ${i + 1}`}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="absolute z-30 flex -translate-x-1/2 bottom-4 left-1/2 space-x-2">
          {images.map((_, i) => (
            <button
              key={i}
              className={`w-3 h-3 rounded-full ${
                i === current ? "bg-white" : "bg-white/50 hover:bg-white"
              }`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
        <button
          onClick={prevSlide}
          className="absolute inset-y-0 left-0 flex items-center justify-center px-4"
        >
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/30 hover:bg-white/50">
            <svg
              className="w-4 h-4 text-white"
              fill="none"
              viewBox="0 0 6 10"
              stroke="currentColor"
            >
              <path d="M5 1 L1 5 L5 9" strokeLinecap="round" strokeWidth="2" />
            </svg>
          </span>
        </button>
        <button
          onClick={nextSlide}
          className="absolute inset-y-0 right-0 flex items-center justify-center px-4"
        >
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/30 hover:bg-white/50">
            <svg
              className="w-4 h-4 text-white"
              fill="none"
              viewBox="0 0 6 10"
              stroke="currentColor"
            >
              <path d="M1 9 L5 5 L1 1" strokeLinecap="round" strokeWidth="2" />
            </svg>
          </span>
        </button>
      </div>

      {/* Three‐column layout */}
      <div className="mt-6 flex gap-6 w-full">
        {/* Left sidebar: fixed width */}
        {/* <aside className="flex-none w-40 flex flex-col space-y-4">
          {sideImages.map((src, i) => (
            <img
              key={`left-${i}`}
              src={src}
              alt={`Sidebar ${i + 1}`}
              className="w-full h-48 object-cover rounded-lg shadow-sm"
            />
          ))}
        </aside> */}

        {/* Center content: up to a max width */}
        <main className="flex-auto max-w-screen">{children}</main>

        {/* Right sidebar: fixed width */}
        {/* <aside className="flex-none w-40 flex flex-col space-y-4">
          {sideImages.map((src, i) => (
            <img
              key={`right-${i}`}
              src={src}
              alt={`Sidebar ${i + 1}`}
              className="w-full h-48 object-cover rounded-lg shadow-sm"
            />
          ))}
        </aside> */}
      </div>
    </div>
  );
};

export default HeroSection;
